// utils/iconImageMap.js
export const ICON_IMAGE_URLS = {
  code: "https://www.denisbitter.de/images/icons/webp/code-min.webp",
  css3: "https://www.denisbitter.de/images/icons/webp/css3-min.webp",
  globe: "https://www.denisbitter.de/images/icons/webp/globe-min.webp",
  react: "https://www.denisbitter.de/images/icons/webp/react-min.webp",
  "3d": "https://www.denisbitter.de/images/icons/webp/3d-min.webp",
  javascript: "https://www.denisbitter.de/images/icons/webp/js-min.webp",
  default: "https://www.denisbitter.de/images/icons/webp/default-min.webp",
  ki: "https://www.denisbitter.de/images/icons/webp/default-min.webp",
    video: "https://www.denisbitter.de/images/icons/webp/video-min.webp",
    c4d: "https://www.denisbitter.de/images/icons/webp/c4d-min.webp",
    "2d": "https://www.denisbitter.de/images/icons/webp/2d-min.webp",
    blender: "https://www.denisbitter.de/images/icons/webp/blender-min.webp",
  aftereffects: "https://www.denisbitter.de/images/icons/webp/ae-min.webp",
  premiere: "https://www.denisbitter.de/images/icons/webp/default-min.webp",
};
